module.exports = __webpack_public_path__ + "static/media/bernstein-blaster.bba8e6f8.png";